import React, { useContext } from 'react';
import { Empty } from 'antd';

import NozomiEventConfigContext from '@totem/components/settings/sections/nozomi/eventConfiguration/nozomiEventConfigContext';
import OrganizationGroup from '@totem/components/settings/sections/nozomi/eventConfiguration/organizationGroup';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNull } from '@totem/utilities/common';

const EventConfigurationLayout = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { data } = useContext(NozomiEventConfigContext);

  const canUserEdit =
    permissions.systemAdministrator.hasPermissions(userProfile);

  if (isNull(data)) {
    return <Empty />;
  }

  return (
    <div>
      <OrganizationGroup canEdit={false} eventConfiguration={data.global} />
      <br />
      <OrganizationGroup
        canEdit={canUserEdit}
        eventConfiguration={data.organization}
      />
    </div>
  );
};

export default EventConfigurationLayout;
